import { gql } from '@apollo/client';

export const removeVoucherCode = gql`
  mutation removeVoucherCode($offerId: String!) {
    removeVoucherCode(offerId: $offerId) {
      _id
      soId
      status
      brandId
      supplementary {
        label
        brandName
        brandCode
        priceChangeModifier {
          amount
          type
          description
        }
        voucherPriceModifier {
          amount
        }
        voucherPriceChangeModifier {
          amount
          type
          description
          code
        }
        numberOfInstallments
        code
        visual {
          highlight
          tooltip
          description
        }
        logoUrl
        fixedCoverages {
          label
          tooltip
          value
          price
          gratis {
            value
            type
          }
          options {
            key
            value
          }
        }
        coverages {
          label
          tooltip
          value
          price
          gratis {
            value
            type
          }
          options {
            key
            value
          }
        }
        discounts {
          value
          tooltip
        }
        paymentSlipInfo {
          amount
          numOfInstallments
        }
        total {
          generalTransfer
          generalTransferWithInstallments
          creditCard
          creditCardWithInstallments
        }
        includedInPrice {
          label
          description
        }
        additionalCoverages {
          label
          description
        }
      }
      additional {
        label
        brandName
        brandCode
        priceChangeModifier {
          amount
          type
          description
        }
        voucherPriceModifier {
          amount
        }
        numberOfInstallments
        code
        visual {
          highlight
          tooltip
          description
        }
        logoUrl
        coverages {
          label
          tooltip
          value
          price
          gratis {
            value
            type
          }
          options {
            key
            value
          }
        }
        fixedCoverages {
          label
          tooltip
          value
          price
          gratis {
            value
            type
          }
          options {
            key
            value
          }
        }
        discounts {
          value
          tooltip
        }
        total {
          generalTransfer
          generalTransferWithInstallments
          creditCard
          creditCardWithInstallments
        }
        includedInPrice {
          label
          description
        }
        additionalCoverages {
          label
          description
        }
      }
      total {
        generalTransfer
        generalTransferWithInstallments
        creditCard
        creditCardWithInstallments
      }
      annotations
    }
  }
`;
